export default ({
    state:{
        showButtonFilter: true,
        showFilter: true,  
    },
    getters: {},
    mutations:{
        /*=============================================================================
        * setShowButtonFilter
        * Controla a exibição do BUTTON FILTER da Aplicação no component TOOLBARS  
        =============================================================================*/
        setShowButtonFilter(state, payload) {
            state.showButtonFilter = payload
        },
        /*=============================================================================
        * setShowFilter
        * Controla a exibição do FILTER da Aplicação no component TOOLBARS  
        =============================================================================*/
        setShowFilter(state, payload) {
            if(payload === undefined) {
                state.showFilter = !state.showFilter
            } else {
                state.showFilter = payload
            }
        },
    }
})
